import { useMemo } from 'react';
import { useTagsForEntityType } from 'src/hooks/useTagsForEntityType';
import {
  getEntityTypeByReportTypeForTag,
  ReportTypesV2,
  tagNameToListingTagColumnName,
  tagNameToPurchaseOrderTagColumnName,
  tagNameToReportingColumnName,
} from 'src/utils/reportsUtils';
import { ActionOutboxEntityType } from 'src/WebApiController';

export type UseReportsTagProps = {
  reportType: ReportTypesV2;
};

export const useReportsTags = ({ reportType }: UseReportsTagProps) => {
  const { tagsMetadata } = useTagsForEntityType(
    getEntityTypeByReportTypeForTag(reportType),
    true
  );

  const { tagsMetadata: listingTagsMetadata } = useTagsForEntityType(
    reportType == ReportTypesV2.SaleV2
      ? ActionOutboxEntityType.Listing
      : undefined,
    true
  );

  const { tagsMetadata: purchaseTagsMetadata } = useTagsForEntityType(
    reportType == ReportTypesV2.SaleV2
      ? ActionOutboxEntityType.Purchase
      : undefined,
    true
  );

  const reportingTagNames = useMemo(() => {
    const reportingTagNames = [];
    reportingTagNames.push(
      ...(tagsMetadata ?? []).map((t) => tagNameToReportingColumnName(t.key))
    );
    reportingTagNames.push(
      ...(listingTagsMetadata ?? []).map((t) =>
        tagNameToListingTagColumnName(t.key)
      )
    );
    reportingTagNames.push(
      ...(purchaseTagsMetadata ?? []).map((t) =>
        tagNameToPurchaseOrderTagColumnName(t.key)
      )
    );
    return reportingTagNames;
  }, [tagsMetadata, listingTagsMetadata, purchaseTagsMetadata]);

  return {
    reportingTagNames,
  };
};
